// ======================================================================
// File Name       : ContentHistoryDetail
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Col, Form, OverlayTrigger, Popover, Row, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Bar, BarChart, Cell, Legend, Rectangle, XAxis, YAxis } from 'recharts';
import {
  COMPLETION_CONDITION_STR,
  CONTENT_TYPE, CONTENT_TYPE_STR, DRILL_KIND, DRILL_KIND_FOR_DISPLAY_BAR_CHART, MAX_COLUMN_BAR_CHART, START_CONDITION
} from '../../../constants/ContentHistoryConstant';
import * as Path from '../../../constants/PathConstants';
import { calculateHistogramYAxisMaxValue, getDrillPercentLearning, isDrillEndCondition } from '../../../utils/ContentUtils';
import { getItemBoxName, parseDateForDetail } from '../../../utils/index';
import { convertGroupListIdToGroupName, convertObjectToList } from '../../../utils/UserUtils';
import BackButton from "../../BackButton";
import PaginationCustom from '../../Pagination';
import TableHead, { setSortState } from "../../TableHead";

const ContentHistoryDetail = ({
  itemInfo,
  userInfo,
  groupList,
  groupRelationList,
  learningEndTimeFrom,
  learningEndTimeTo,
  learningHistoryInfo,
  recordNum,
  getStartEndData,
  startPosition,
  handleSortState,
  goBack,
  itemDetail,
  dataSort,
  drillImplementationStatusList,
  isDisplayBarGraph,
  histogramDataMax,
}) => {
  const theadContentDrillMovie = [
    { title: 'ユーザー名', sortBy: null },
    { title: 'ユーザーグループ名', sortBy: null },
    { title: '実績', sortBy: null, width: 70 },
    { title: '学習開始日時', sortBy: 6, width: 200 },
    { title: '学習完了日時', sortBy: 7, width: 200 },
  ];
  const thead = [
    { title: 'ユーザー名', sortBy: null },
    { title: 'ユーザーグループ名', sortBy: null },
    { title: '学習開始日時', sortBy: 6, width: 200 },
    { title: '学習完了日時', sortBy: 7, width: 200 },
  ];
  let data = thead;
  if (dataSort) {
    const sortBy = dataSort.learningHistorySortType;
    const sortState = dataSort.ascendingDescendingSort;
    data = setSortState(thead, sortBy, sortState);
  }
  let dataContentDrillMovie = thead;
  if (dataSort) {
    const sortBy = dataSort.learningHistorySortType;
    const sortState = dataSort.ascendingDescendingSort;
    dataContentDrillMovie = setSortState(theadContentDrillMovie, sortBy, sortState);
  }
  let isContentTypeMovieOrDrill = false;
  let isContentTypeMovie = false;
  let isContentTypeDrill = false;
  let link = '';
  if (itemDetail && itemDetail.contentInfo) {
    const { contentType } = itemDetail.contentInfo;
    isContentTypeMovieOrDrill = contentType === CONTENT_TYPE.MOVIE ||
                                contentType === CONTENT_TYPE.DRILL_TEST;
    isContentTypeMovie = contentType === CONTENT_TYPE.MOVIE;
    isContentTypeDrill = contentType === CONTENT_TYPE.DRILL_TEST;
    link = Path.USER_HISTORY_AGGREGATE_BY_PROBLEM_DETAIL.replace(':id', itemDetail.itemSecernId); // #7386
  }

  const learningHistoryList =
    learningHistoryInfo &&
    learningHistoryInfo.map((learningHistory, index) => {
      const {
        drillHistoryInfo,
        itemSecernId,
       } = learningHistory;
      const videoViewRate = learningHistory.videoViewRate ? `${learningHistory.videoViewRate}%` : `${0}%`;

      // get drill percent learning
      let displayText = '-';
      if (learningHistory && learningHistory.drillHistoryInfo) {
        displayText = getDrillPercentLearning(learningHistory.drillHistoryInfo);
      }

      let isDrillEnd = true;
      if (learningHistory && learningHistory.drillHistoryInfo &&
        itemInfo && itemInfo.bySecernId[itemSecernId]) {
        const itemInfoData = itemInfo.bySecernId[itemSecernId];
        isDrillEnd = isDrillEndCondition(drillHistoryInfo, itemInfoData);
      }

      const userName = userInfo.bySecernId[learningHistory.userSecernId]
        ? userInfo.bySecernId[learningHistory.userSecernId].userName
        : '';
      const groupListByUser = convertObjectToList(
        groupRelationList,
        'userSecernId',
        'groupSecernId',
      );
      let groupName = '';
      if (groupListByUser && groupListByUser[learningHistory.userSecernId]) {
        const groupSecernIdList = groupListByUser[learningHistory.userSecernId].groupSecernId;
        groupName = convertGroupListIdToGroupName(groupSecernIdList, groupList);
      }

      // Step 10.3.0 START
      let popoverHoverFocus = null;
      if (isContentTypeMovie) {
        popoverHoverFocus = (
          <Popover id="popover-trigger-hover-focus">
            <Popover.Body>
              <span>
                {'再生された時間：'}
                {parseInt(learningHistory.actualVideoPlayTime, 10) || 0}
                {' 秒'}
              </span>
            </Popover.Body>
          </Popover>
        );
      } else {
        popoverHoverFocus = (
          <Popover id="popover-trigger-hover-focus">
            <Popover.Header>ドリル実施条件</Popover.Header>
            <Popover.Body>
              <span>
                {'スタート条件：'}
                {learningHistory && learningHistory.drillHistoryInfo &&
                getItemBoxName(START_CONDITION, learningHistory.drillHistoryInfo.startCondition)}
              </span>
              <br />
              <span>
                {'ドリル種別：'}
                {learningHistory && learningHistory.drillHistoryInfo &&
                getItemBoxName(DRILL_KIND, learningHistory.drillHistoryInfo.drillKind)}
              </span>
              <br />
              <span>
                {'ドリル作成者：'}
                {learningHistory.courseSecernId && learningHistory.courseSecernId.startsWith('adhoc_') ?
                'サービス利用ユーザー' : '管理画面利用ユーザー'}
              </span>
            </Popover.Body>
          </Popover>
        );
      }
      // Step 10.3.0 END

      return (
        <OverlayTrigger
          trigger={isContentTypeDrill || isContentTypeMovie ? ['hover', 'focus'] : []}
          placement="top"
          overlay={popoverHoverFocus}
          key={index}
        >
          <tr key={index} className={!isDrillEnd ? 'danger' : ''}>
            <td>
              {userName}
            </td>
            <td>
              {groupName}
            </td>
            {isContentTypeMovie &&
              <td className="text-center">
                {videoViewRate}
              </td>}
            {isContentTypeDrill &&
              <td className="text-center">
                {displayText}
              </td>}
            <td>
              {parseDateForDetail(learningHistory.learningStartTime)}
            </td>
            <td>
              {parseDateForDetail(learningHistory.learningEndTime)}
            </td>
          </tr>
        </OverlayTrigger>
      );
    });

  // #7386 START
  const renderCustomizedBarLegend = ({ payload }) => {
    return (
      <div>
        {payload.map((entry, index) => {
          const { dataKey, data } = entry;
          return (
            <div key={dataKey} className='margin-bottom-10'>
              <svg width={30} height={5}>
                <rect cx={5} cy={5} width={30} height={5} fill={"#99FF99"} />
              </svg>
              <span className="margin-left-10" key={dataKey}>{data}</span>
            </div>
          );
        })}
      </div>
    );
  };

  const completionBarWidth = 3; // width of completion bar
  const columnPadding = 0.5;
  const paddingWidthPerNum = 35;
  const numCount = String(histogramDataMax).length;
  const widthPerNum = 17.5;
  const columnFixWidth = 27;
  const firstColumnWidth = 25;

  const ConditionalRectangleBar = ({ payload, ...rest }) => {
    let { x, y, height, fill, stroke } = rest;
    const colIndex = payload.actualResultType / MAX_COLUMN_BAR_CHART;
    if (colIndex === 1) { // first column
      x = firstColumnWidth;
    } else {
      x = firstColumnWidth + (colIndex - 1) * columnFixWidth + (colIndex - 1) * columnPadding;
    }

    rest.width = columnFixWidth;
    if (payload.columnName === COMPLETION_CONDITION_STR) {
      rest.width = completionBarWidth;
      x = x - completionBarWidth + columnFixWidth + columnPadding;
      if (payload.actualResultType < 100) {
        // align center
        x = x + completionBarWidth / 2;
      }
    }
    return (
      <Rectangle
        stroke={stroke}
        fill={fill}
        x={x + (numCount - 2) * widthPerNum}
        y={y}
        height={height}
        width={rest.width}
        />
    );
  };
  // #7386 END

  // #7462 START
  const CustomizedAxisTick = (props) => {
    const { x, y, payload } = props;
    return (
      <g transform={`translate(${payload.value === 100 ? x : x + 3},${y})`}>
        <text x={0} y={0} dy={4} textAnchor="end">
          {payload.value}
        </text>
      </g>
    );
  };
  // #7462 END

  return (
    <div>
      <Col sm={12}>
        <Form className='form-horizontal'>
          <Form.Group className="form-info">
            <Col sm={3} className="form-label">
              コンテンツ識別ID
            </Col>
            <Col sm={7} className="padding-top-bottom-10">
              {itemDetail && itemDetail.contentInfo && itemDetail.contentInfo.contentSecernId}
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col sm={3} className="form-label">
              コンテンツ名
            </Col>
            <Col sm={7} className="padding-top-bottom-10">
              {itemDetail && itemDetail.contentInfo && itemDetail.contentInfo.contentName}
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col sm={3} className="form-label">
              コンテンツ種別
            </Col>
            <Col sm={7} className="padding-top-bottom-10">
              {itemDetail && itemDetail.contentInfo &&
                getItemBoxName(CONTENT_TYPE_STR, itemDetail.contentInfo.contentType)}
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col sm={3} className="form-label">
              コース表示名称
            </Col>
            <Col sm={7} className="padding-top-bottom-10">
              {itemDetail && itemDetail.itemName}
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col sm={3} className="form-label">
              実施回数
            </Col>
            <Col sm={7} className="padding-top-bottom-10">
              {recordNum}
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col sm={3} className="form-label">
              実施期間
            </Col>
            {(learningEndTimeFrom ||
              learningEndTimeTo) &&
              <Col sm={7} className="padding-top-bottom-10">
                {learningEndTimeFrom || ''} ～ {learningEndTimeTo || ''}
              </Col>}
          </Form.Group>
          {/* #7386 START */}
          {
            isDisplayBarGraph && drillImplementationStatusList && (
              <Form.Group className="form-info">
                <Col sm={3} className="form-label">
                  成績分布
                </Col>
                <Col sm={9} className="padding-left-right-clear">
                  <BarChart
                    width={300 + (numCount - 2) * widthPerNum}
                    height={200}
                    data={drillImplementationStatusList}
                    barCategoryGap={0} // display consecutive bar
                    margin={{
                       top: 0,
                       right: 0,
                       bottom: 0,
                       left: -(widthPerNum * numCount),
                    }}
                    style={{
                      fontSize: "0.6rem"
                    }}
                  >
                    <XAxis 
                      dataKey="columnId"
                      type="number"
                      tickLine={false}
                      ticks={[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]} // custom sticks are displayed
                      interval={0} // show all ticks
                      tick={<CustomizedAxisTick />}
                    />
                    <YAxis 
                      tickLine={false}
                      ticks={[
                        0,
                        0.2 * histogramDataMax,
                        0.4 * histogramDataMax,
                        0.6 * histogramDataMax,
                        0.8 * histogramDataMax,
                        histogramDataMax
                      ]}
                      width={paddingWidthPerNum * (numCount - 2) + 60 }
                    />
                    <Bar dataKey="actualResultUserCount" fill="#DCE6F2" stroke="#4A7EBB" shape={<ConditionalRectangleBar />}>
                      {drillImplementationStatusList.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={entry.columnName === COMPLETION_CONDITION_STR ? '#99FF99' : '#DCE6F2'} />
                      ))}
                    </Bar>
                    <Legend
                      layout="vertical"
                      verticalAlign="middle"
                      width={150}
                      wrapperStyle={{
                        marginLeft: `${240 + numCount * 8 }px`,
                        marginTop: `${60 - numCount / 2 }px`,
                      }}
                      payload={[{ data: '完了条件', dataKey: COMPLETION_CONDITION_STR }]}
                      content={renderCustomizedBarLegend}
                    />
                  </BarChart>
                </Col>
              </Form.Group>
            )}

          {/* #7437 START */}
          {isContentTypeDrill && (
            <Col sm={12} className="text-center margin-top-10 margin-bottom-10">
              <Link
                className="btn btn-primary btn-96"
                role='button'
                to={{ pathname: link }}
              >
                解答内訳をみる
              </Link>
            </Col>
          )}
          {/* #7437 END */}

          {/* #7386 END */}
          <br />
          <br />
        </Form>
      </Col>
      <Table striped hover className="table1">
        {isContentTypeMovieOrDrill &&
          <thead>
            <TableHead data={dataContentDrillMovie} handleSortState={handleSortState} />
          </thead>}
        {!isContentTypeMovieOrDrill &&
          <thead>
            <TableHead data={data} handleSortState={handleSortState} />
          </thead>}
        <tbody>
          {learningHistoryList}
        </tbody>
      </Table>
      <Form.Group>
        <Col className="d-flex justify-content-center">
          <PaginationCustom
            recordNum={recordNum}
            handlePageSelect={getStartEndData}
            startPosition={startPosition}
          />
        </Col>
      </Form.Group>
    </div>
  );
};

export default ContentHistoryDetail;
